import styled from 'styled-components';
import { Tooltip, Badge } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

const StyledContainerForInfoBadge = styled.span`
  position: relative;
  top: -2px;
  margin-left: 10px;

  .badge .anticon {
    color: #c7c5c5;
  }
`;

const InfoBadge = (props) => {
  return (
    <StyledContainerForInfoBadge>
      <Tooltip title={props.tooltip}>
        <Badge className='badge' count={<InfoCircleFilled />} />
      </Tooltip>
    </StyledContainerForInfoBadge>
  );
};

export { InfoBadge };